import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './PassportInfoDataForm.html?raw';
import on from 'dojo/on';
import CollapsibleSection from '../CollapsibleSection/CollapsibleSection';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import '../../../moreCore/UI/SelectBox/SelectBox';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/DateInput/DateInput';
import Button from '../../../moreCore/UI/Button/Button';
import '../../../moreCore/UI/Button/Button';
import domConstruct from 'dojo/dom-construct';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';

class PassportInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    newPassportContainer: HTMLElement;
    selectedPassportInfoContainer: HTMLElement;
    passportSelect: MdsLax<InstanceType<typeof SelectBox>>;
    allPassports: Array<IndividualData_PassportInfo>;
    btn_setAsInactive: HTMLElement;

    readonlyPassportIsActive: HTMLInputElement;
    readonlyPassportNumber: HTMLInputElement;
    readonlyPassportValidFrom: HTMLInputElement;
    readonlyPassportValidUntil: HTMLInputElement;
    readonlyPassportIssuedAuthority: HTMLInputElement;

    newPassportNumber: MdsLax<InstanceType<typeof Edit>>;
    newPassportValidFrom: MdsLax<InstanceType<typeof DateInput>>;
    newPassportValidUntil: MdsLax<InstanceType<typeof DateInput>>;
    newPassportIssuedAuthority: MdsLax<InstanceType<typeof Edit>>;
    newPassportIssuedCountry: MdsLax<InstanceType<typeof SearchSelect>>;
    newPassportIsMainDocument: MdsLax<InstanceType<typeof CheckBox>>;
    saveNewPassportBtn: MdsLax<InstanceType<typeof Button>>;
    newPassportErrorContainer: HTMLElement;
    newPassportErrorMessage: HTMLElement;


    formData: IndividualData_PassportSave = {
        personal_doc_number: "",
        issued_country: "",
        issued_authority_original: "",
        date_valid_from: null,
        date_valid_until: null,
        is_main_document: false
    };
    originalData: string = "";

    loadFormData(data: Array<IndividualData_PassportInfo>): void {

        this.allPassports = data;

        this.allPassports.length > 0 ? this.passportSelect.setPlaceholder(this.translations["FormLabel_AllPassports_Placeholder"]) : this.passportSelect.setPlaceholder(this.translations["FormLabel_AllPassports_Placeholder_empty"]);

        //this.passportSelect.setPlaceholder("Your passports!");
        this.passportSelect.clear();

        data.forEach(pass => {

            this.passportSelect.addOption(pass.ID, `${pass.personal_doc_number} - ${pass.date_valid_until}`);
        });

        this.passportSelect.constructOptions();
        if (this.passportSelect.entries.length > 0) this.passportSelect.setValue(this.passportSelect.entries[0].value);

        this.constructPassportInfo(this.passportSelect.getValue());

        this.createNewPassportSection();
    }

    createNewPassportSection(): void {

        this.UiModder.domConstruct.empty(this.newPassportContainer);

        let cs = new CollapsibleSection();
        cs.sectionName = "new_passport_section";
        cs.isEditable = false;
        cs.collapsibleHeading.innerHTML = this.translations["FormLabel_Collapsible_NewPassport"];
        cs.placeAt(this.newPassportContainer);

        this.UiModder.domConstruct.empty(cs.collapsibleContainer);

        //County
        let div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.newPassportIssuedCountry.setLabel(this.translations["FormLabel_IssuedCountry"]);
        this.newPassportIssuedCountry.labelAttribute = "description";
        this.newPassportIssuedCountry.setPlaceholder(this.translations["FormLabel_IssuedCountry_Placeholder"]);
        this.newPassportIssuedCountry.setDropDownPositionAbsolute(false);
        this.newPassportIssuedCountry.setUrl("IndividualDataSheet/GetNationalitiesValues");
        this.UiModder.domClass.add(this.newPassportIssuedCountry.domNode, "w3-quarter");
        this.newPassportIssuedCountry.placeAt(div);
        this.newPassportIssuedCountry.loadListValues();
        on(this.newPassportIssuedCountry, "change", lang.hitch(this, this._onChange_newPassportData));

        //Passport Number
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.newPassportNumber.setLabel(this.translations["FormLabel_PassportNumber"]);
        this.newPassportNumber.setMandatory(true);
        this.UiModder.domClass.add(this.newPassportNumber.domNode, "w3-quarter");
        this.newPassportNumber.placeAt(div);
        on(this.newPassportNumber, "change", lang.hitch(this, this._onChange_newPassportData));

        //Issued Authority
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.newPassportIssuedAuthority.setLabel(this.translations["FormLabel_IssuedAuthority"]);
        this.newPassportIssuedAuthority.setMandatory(true);
        this.UiModder.domClass.add(this.newPassportIssuedAuthority.domNode, "w3-quarter");
        this.newPassportIssuedAuthority.placeAt(div);
        on(this.newPassportIssuedAuthority, "change", lang.hitch(this, this._onChange_newPassportData));

        //Passport Valid Dates
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.newPassportValidFrom.setLabel(this.translations["FormLabel_DateValidFrom"]);
        this.newPassportValidFrom.setMaxValue(new Date);
        this.newPassportValidFrom.setMandatory(true);
        this.UiModder.domClass.add(this.newPassportValidFrom.domNode, "w3-quarter w3-margin-right");
        this.newPassportValidFrom.placeAt(div);
        on(this.newPassportValidFrom, "change", lang.hitch(this, this._onChange_newPassportData));

        this.newPassportValidUntil.setLabel(this.translations["FormLabel_DateValidUntil"]);
        this.newPassportValidUntil.setMinValue(new Date);
        this.newPassportValidUntil.setMandatory(true);
        this.UiModder.domClass.add(this.newPassportValidUntil.domNode, "w3-quarter");
        this.newPassportValidUntil.placeAt(div);
        on(this.newPassportValidUntil, "change", lang.hitch(this, this._onChange_newPassportData));

        //Main document checkbox
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.newPassportIsMainDocument.setLabel(this.translations["FormLabel_MainDocument"]);
        this.UiModder.domClass.add(this.newPassportIsMainDocument.domNode, "w3-quarter");
        this.newPassportIsMainDocument.placeAt(div);
        on(this.newPassportIsMainDocument, "change", lang.hitch(this, this._onChange_newPassportData));

        //Save Btn
        div = domConstruct.create("div", { class: "w3-container w3-padding" }, cs.collapsibleContainer);

        this.saveNewPassportBtn.setLabel(this.translations["General_Save"]);
        this.saveNewPassportBtn.setClasses("mds-button-base w3-padding w3-disabled round mds-hover-bright accentBG", " ");
        this.saveNewPassportBtn.setIconLeft("fas fa-save");
        this.saveNewPassportBtn.on("click", lang.hitch(this, this._onClick_saveBtn));
        this.saveNewPassportBtn.placeAt(div);

        //Error container
        this.newPassportErrorContainer = domConstruct.create("div", {
            class: "w3-container w3-padding w3-round w3-pale-red w3-text-red w3-hide flex_row_center w3-margin",
            style: "flex-wrap:nowrap"
        }, cs.collapsibleContainer);

        domConstruct.create("div", {
            class: "w3-text-red",
            innerHTML: '<i class="fa fa-exclamation-triangle">&nbsp;</i>'
        }, this.newPassportErrorContainer);

        this.newPassportErrorMessage = domConstruct.create("div", {}, this.newPassportErrorContainer);
    }

    constructPassportInfo(passId: string): void {

        let pass: IndividualData_PassportInfo = this.allPassports.filter(x => x.ID === passId)[0];

        console.debug("PASS", pass);

        if (pass) {

            this.UiModder.domClass.remove(this.selectedPassportInfoContainer, "w3-hide");

            let date_from: Array<string> = pass.date_valid_from.split(".");
            let date_until: Array<string> = pass.date_valid_until.split(".");

            if (pass.is_active) {

                this.readonlyPassportIsActive.value = this.translations["General_Yes"];
                this.UiModder.domClass.remove(this.btn_setAsInactive, "w3-hide w3-disabled");
            } else {

                this.readonlyPassportIsActive.value = this.translations["General_No"];
                this.UiModder.domClass.add(this.btn_setAsInactive, "w3-hide w3-disabled");
            }

            this.readonlyPassportNumber.value = pass.personal_doc_number;
            this.readonlyPassportValidFrom.valueAsDate = new Date(`${date_from[2]}-${date_from[1]}-${date_from[0]}`);
            this.readonlyPassportValidUntil.valueAsDate = new Date(`${date_until[2]}-${date_until[1]}-${date_until[0]}`);
            this.readonlyPassportIssuedAuthority.value = pass.issued_authority_original;
        } else {

            this.UiModder.domClass.add(this.selectedPassportInfoContainer, "w3-hide");
        }
    }

    serializeFormData(): void {

        this.formData.personal_doc_number = this.newPassportNumber.getValue();
        this.formData.issued_country = this.newPassportIssuedCountry.getValue();
        this.formData.issued_authority_original = this.newPassportIssuedAuthority.getValue();
        this.formData.date_valid_from = this.newPassportValidFrom.getValue();
        this.formData.date_valid_until = this.newPassportValidUntil.getValue();
        this.formData.is_main_document = this.newPassportIsMainDocument.getValue();

        this.checkSaveButtonDisable();

        console.debug("SERIALIZE DATA:", this.formData);
    }

    checkSaveButtonDisable(): void {

        if (this.isValid()) {

            this.saveNewPassportBtn.setClasses(" ", "w3-disabled");
            this.showNewPassportErrorMessage(false);
        } else {

            this.saveNewPassportBtn.setClasses("w3-disabled", " ");
        }
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.personal_doc_number) {

            this.UiModder.domClass.add(this.newPassportNumber.inputNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.newPassportNumber.inputNode, "w3-pale-red");
        }
        if (!this.formData.issued_country) {

            //this.UiModder.domClass.add(this.newPassportIssuedCountry.outerInput, "w3-pale-red");
            b = false;
        } else {

            //this.UiModder.domClass.remove(this.newPassportIssuedCountry.outerInput, "w3-pale-red");
        }
        if (!this.formData.issued_authority_original) {

            this.UiModder.domClass.add(this.newPassportIssuedAuthority.inputNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.newPassportIssuedAuthority.inputNode, "w3-pale-red");
        }
        if (!this.formData.date_valid_from) {

            this.UiModder.domClass.add(this.newPassportValidFrom.inputNode, "w3-pale-red");
            b = false;
        } else {

            this.UiModder.domClass.remove(this.newPassportValidFrom.inputNode, "w3-pale-red");
        }
        if (!this.formData.date_valid_until) {

            this.UiModder.domClass.add(this.newPassportValidUntil.inputNode, "w3-pale-red");
            b = false;
        } else {

            if (this.formData.date_valid_until <= new Date()) {

                this.UiModder.domClass.add(this.newPassportValidUntil.inputNode, "w3-pale-red");
                b = false;
            } else {

                this.UiModder.domClass.remove(this.newPassportValidUntil.inputNode, "w3-pale-red");
            }
        }

        if (this.formData.date_valid_from && this.formData.date_valid_until) {

            if (this.formData.date_valid_from > this.formData.date_valid_until) {

                this.UiModder.domClass.add(this.newPassportValidFrom.inputNode, "w3-pale-red");
                this.UiModder.domClass.add(this.newPassportValidUntil.inputNode, "w3-pale-red");
                b = false;
            }
        }

        return b;
    }

    _onChange_newPassportData() {

        this.serializeFormData();
    }

    _onClick_saveBtn(): void {

        this.serializeFormData();

        if (this.isValid()) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SaveFormData";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.formData),
                    sectionName: IndividualData_SectionName.PassportInfo
                },
                lang.hitch(this, this._onSaveFormDataResponse),
                lang.hitch(this, this._onSaveFormDataError),
                false // sync
            );
        } else {

            this.showNewPassportErrorMessage(true, this.translations["IndividualDataSheet_ContactData_DataNotValid"]);
        }
    }

    _onSaveFormDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
        //this.UiModder.domClass.add(dlg.modalDlgContentNode, "w3-round");
        //this.UiModder.domStyle.set(dlg.textNode, "min-height", "150px");
        //this.UiModder.domClass.replace(dlg.headerBarNode, "mds-bg-orange", "secondaryBG");
        //this.UiModder.domClass.add(dlg.textNode, "w3-padding-64 w3-container w3-center");

        dlg.show(this.translations["FormDialog_Document_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("DataForm_close");
    }

    _onClick_setAsInactiveBtn(): void {

        let dlg = new GenericDialog();

        dlg.show(this.translations["FormDialog_Passport_setAsInaktive"], this.translations["FormLabel_IsAktive"], null, "fas fa-question", "yesno", lang.hitch(this, this.setPassportAsInactive));
        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");
    }

    setPassportAsInactive(dlgResult: any): void {

        if (dlgResult === 2) {

            let requestUrl = window.appRoot + "IndividualDataSheet/SetPassportAsInactive";
            this.StandbyStart();

            this.RequestManager.post(
                requestUrl,
                {
                    passId: this.passportSelect.getValue()
                },
                lang.hitch(this, this._onSetPassportAsInactiveResponse),
                lang.hitch(this, this._onSetPassportAsInactiveError),
                false // sync
            );
        }        
    }

    _onSetPassportAsInactiveResponse(): void {

        this.refreshData();
    }

    refreshData(): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/GetSectionDataByName";

        this.RequestManager.post(
            requestUrl,
            {
                sectionName: IndividualData_SectionName.PassportInfo
            },
            lang.hitch(this, this._onRefreshDataResponse),
            lang.hitch(this, this._onRefreshDataError),
            false // sync
        );
    }

    _onRefreshDataResponse(data: Array<IndividualData_PassportInfo>): void {

        this.StandbyStop();

        this.loadFormData(data);
    }

    _onChange_SelectedPassport(): void {

        this.constructPassportInfo(this.passportSelect.getValue());
    }

    _onChangePassportDataInput(): void {

        
    }

    _onRefreshDataError(err): void {

        this.StandbyStop();
        alert(err.Message);
    }

    _onSetPassportAsInactiveError(err): void {

        this.StandbyStop();
        alert(err.Message);
    }

    _onSaveFormDataError(err): void {

        this.StandbyStop();

        this.showNewPassportErrorMessage(true, err.Message);
    }

    showNewPassportErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.newPassportErrorContainer, "w3-hide");
            msg ? this.newPassportErrorMessage.innerHTML = msg : this.newPassportErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.newPassportErrorContainer, "w3-hide");
            this.newPassportErrorMessage.innerHTML = "";
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(PassportInfoDataForm.prototype, {
  newPassportNumber: () => (new Edit()),
  newPassportValidFrom: () => (new DateInput()),
  newPassportValidUntil: () => (new DateInput()),
  newPassportIssuedAuthority: () => (new Edit()),
  newPassportIssuedCountry: () => (new SearchSelect()),
  newPassportIsMainDocument: () => (new CheckBox()),
  saveNewPassportBtn: () => (new Button()),
});
export default mdsWidget(PassportInfoDataForm);